import React, {  lazy } from "react";
import { Outlet } from "react-router-dom";
import SuspenseWrapper from "../SuspenseWrapper";


const HonorTabcomponent = SuspenseWrapper(lazy(()=> import("components/HonorHub-Certificate/HonorTabcomponent")));
const CertificateTabComponent = SuspenseWrapper(lazy(()=> import("components/HonorHub-Certificate/CertificateTabComponent")));

const HonorHubRoutes = {
    path: "honorhub-certificate",
    element: <Outlet />,
    children: [
        {
            path: "list",
            element: <HonorTabcomponent />,
        },
        {
            path: "certificate",
            element: <CertificateTabComponent />
        }
    ],
};

export default HonorHubRoutes;